module.exports = __webpack_public_path__ + "static/media/ios-contrast.1b6f1155.svg";